export const CREATE_PROJECT = 'createProject';
export const CREATE_PROJECTS = 'createProjects';
export const EDIT_PROJECT = 'editProject';
export const FETCH_PROJECT_BY_ID = 'fetchProjectById';
export const FETCH_ALL_PROJECTS = 'fetchAllProjects';
export const FETCH_USER_PROJECTS = 'fetchUserProjects';
export const FETCH_ORGANIZATION_PROJECTS = 'fetchOrganizationProjects';
export const FETCH_ORGANIZATION_ACTIVE_PROJECT_COUNT = 'fetchOrganizationProjectCount';
export const FETCH_BILLS_BY_PROJECT_ID = 'fetchBillsByProjectId';
